function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 28,
  cy: 28,
  r: 28,
  fill: "#349EDB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M35.936 29.63c-.416-.51-.297-.737 0-1.193.006-.005 3.444-4.608 3.798-6.169l.002-.001c.176-.569 0-.987-.851-.987h-2.817c-.717 0-1.047.359-1.224.76 0 0-1.434 3.326-3.463 5.482-.655.623-.958.823-1.315.823-.176 0-.45-.2-.45-.769v-5.309c0-.682-.2-.987-.794-.987h-4.429c-.45 0-.717.318-.717.615 0 .646 1.015.795 1.12 2.615v3.95c0 .864-.162 1.023-.522 1.023-.957 0-3.281-3.339-4.658-7.16-.278-.742-.55-1.042-1.272-1.042h-2.818c-.804 0-.966.359-.966.76 0 .71.957 4.236 4.452 8.895 2.33 3.18 5.61 4.904 8.594 4.904 1.793 0 2.012-.383 2.012-1.041 0-3.039-.162-3.326.737-3.326.416 0 1.133.2 2.808 1.734 1.914 1.819 2.228 2.633 3.3 2.633h2.816c.803 0 1.21-.383.975-1.138-.535-1.588-4.155-4.854-4.318-5.073z",
  fill: "#fff"
});

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.0b4d709a.svg";
export { ForwardRef as ReactComponent };